export default __webpack_public_path__ + "static/media/CHARLIE.d7b4d484.png";